module.exports = __webpack_public_path__ + "media/images/delete-73441bdb.svg";